/**
 * Globale PDF-Vorschau (User-Wunsch: alle PDFs erst live anzeigen, dann
 * herunterladen/drucken). Ein einziger `PdfPreviewHost` registriert die
 * Anzeige-Funktion; überall im Code ruft man `previewPdfResponse`/`previewPdfBlob`
 * auf — egal ob React-Komponente oder Util. Ist (noch) kein Host registriert,
 * fällt es sauber auf den klassischen Download zurück.
 */
let _show = null;

export function registerPdfPreview(fn) {
    _show = fn;
}

function _fallbackDownload(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "dokument.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

/** Zeigt ein PDF-Blob in der globalen Vorschau (oder lädt es ersatzweise herunter).
 *  `opts.recipient = { name, email, phone }` befüllt den „Senden"-Dialog vor. */
export function previewPdfBlob(blob, filename, opts = {}) {
    if (_show) _show(blob, filename || "dokument.pdf", opts || {});
    else _fallbackDownload(blob, filename);
}

/** Bequem für axios-Antworten mit `responseType: "blob"`. */
export function previewPdfResponse(res, filename, opts = {}) {
    previewPdfBlob(new Blob([res.data], { type: "application/pdf" }), filename, opts);
}

/** Bequem für ein noch laufendes axios-Promise (await + Vorschau). */
export async function previewPdfRequest(promise, filename, opts = {}) {
    const res = await promise;
    previewPdfResponse(res, filename, opts);
}

/** Jun-2026 (User-Wunsch) — Empfänger aus Kunden-/Käuferdaten für den
 *  „Senden"-Dialog vorbefüllen (E-Mail + Handynummer für WhatsApp/SMS). */
export function customerRecipient(c) {
    if (!c) return undefined;
    const name = (c.company_name
        || [c.first_name, c.last_name].filter(Boolean).join(" ")
        || c.name || c.customer_name || "").trim();
    const email = c.email || c.customer_email || "";
    const phone = c.phone_mobile || c.mobile || c.phone || c.customer_phone || "";
    if (!email && !phone) return undefined;
    return { name, email, phone };
}
